import Submit from "./submit";
import {EvalFormat} from "./evalformat";
import {ChartBuilder} from "./chartbuilder";

window.addEventListener("load", function () {
    let kpiBoxes = Array.from(document.querySelectorAll(".kpi-box"));

    // install click handlers
    kpiBoxes.forEach(kpiBox => {
        kpiBox.addEventListener("click", function (evt) {

            // remove selected class
            kpiBoxes.forEach(b => {
                b.classList.remove("selected");
            });


            let b = evt.target.closest(".kpi-box");
            b.classList.add("selected");


            let queryDomElement = kpiBox.closest(".content-box").querySelector("script[type='api/kpi-timeseries']");
            loadFromDomScript(queryDomElement);

        });
    });
});

function transpose(a) {
    return Object.keys(a[0]).map(function(c) {
        return a.map(function(r) { return r[c]; });
    });
}

async function loadFromDomScript(queryDomElement) {
    let contentBox = queryDomElement.closest(".content-box");
    let selectedKpiBoxes = Array.from(contentBox.querySelectorAll(".kpi-box.selected"));

    // get the columns from the selected kpi boxes
    let projection = selectedKpiBoxes.map((box) => {
       return box.querySelector("script[type='measure/fragment']").innerText.trim();
    }).join(", ");

    // stitch in the projection and query
    let query = queryDomElement.innerText.replace("#projection", projection);
    const response = await Submit.submit(query, "data/query");

    let transposed = transpose(response.rows);

    // pluck off the first columns
    let timeColumnName = response.headers.shift();
    let categories = transposed.shift();

    let builder = new ChartBuilder();

    // collect the timeseries
    for (let i=0;i<transposed.length;++i)
        builder.addSeries(response.headers[i], transposed[i]);

    builder.setLabels(categories);

    // accessible within eval scripts
    let fmt = EvalFormat;
    let valueFormatter = contentBox.querySelector(".kpi-box.selected script[type='value/formatter']");
    if (valueFormatter)
        builder.setYAxisFormat(eval("(" + valueFormatter.innerText + ")"));

    // get or create div that exists as a child right before the script element
    let containerElement = queryDomElement.parentNode.querySelector(".timeseries-chart-container");

    if (containerElement != null)
        containerElement.remove();

    containerElement = document.createElement("div");
    containerElement.classList.add("timeseries-chart-container");
    let canvas = document.createElement("canvas");
    containerElement.appendChild(canvas);
    builder.build(canvas);

    queryDomElement.parentNode.insertBefore(containerElement, queryDomElement);
}

const KPITimeSeries = {
    "loadFromDomScript": loadFromDomScript
};

export default KPITimeSeries;